
import { mapGetters } from 'vuex'
import { jsFn } from '@/utils/js-fn'
import CountryCode from '@/components/tool/countryCode/Index.vue'
// import countrys from '@/assets/js/country.json'
import countrys from '@/assets/js/country_v2.json'

export default {
    name: 'updbasicinfo',
    data() {
        // 電話驗證
        const validCellphone = (rule, value, callback) => {
            if(!jsFn.isEmpty(value)) {
                if (jsFn.isEmpty(this.extendform.countryCode)) {
                    callback(new Error(this.$t('error_6')))
                } else if (!(/^[0-9]*$/.test(value))) {
                    callback(new Error(this.$t('error_7')))
                } else if (this.extendform.countryCode === 886 && value.length < 9) {
                    callback(new Error(this.$t('error_26')))
                } else {
                    callback()
                }
            } else {
                callback()
            }
        }
        // Emai 驗證
        const validEmail = (rule, value, callback) => {
            if(!jsFn.isEmpty(value)) {
                let emailRule = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/
                if (value.search(emailRule) !== -1) {
                    callback()
                } else {
                    callback(new Error(this.$t('error_4')))
                }
            } else {
                callback()
            }
        }
        return {
            schoolOptionFlag: false,
            maskFlag: true,
            areaOptionFlag: false,
            areaOption: [],
            schoolOption: [],
            schooltFilterText: '',
            extendform: {
                name: '',
                jobTitle: '',
                country: null,
                province: null,
                city: null,
                unitName: '',
                unitType: '',
                areaStr: '',
                schoolCode: '',
                countryCode: '',
                mobile: '',
                mail: ''
            },
            updInfoRule: {
                name: {
                    required: true,
                    message: this.$t('error_1'),
                    trigger: 'blur'
                },
                jobTitle: {
                    required: true,
                    message: this.$t('error_1'),
                    trigger: 'blur'
                },
                unitType: {
                    required: true,
                    message: this.$t('error_1'),
                    trigger: 'blur'
                },
                areaStr: {
                    required: true,
                    message: this.$t('error_1'),
                    trigger: 'blur'
                },
                unitName: {
                    required: true,
                    message: this.$t('error_1'),
                    trigger: 'blur'
                },
                mail: {
                    validator: validEmail,
                    trigger: 'blur'
                },
                mobile: {
                    validator: validCellphone,
                    trigger: 'blur'
                }
            },
            unitTypes: [
                {
                    label: this.$t('extend_1'),
                    value: '1'
                },
                {
                    label: this.$t('extend_2'),
                    value: '2'
                },
                {
                    label: this.$t('extend_3'),
                    value: '3'
                },
                {
                    label: this.$t('extend_4'),
                    value: '4'
                },
                {
                    label: this.$t('extend_5'),
                    value: '5'
                },
                {
                    label: this.$t('extend_6'),
                    value: '6'
                },
                {
                    label: this.$t('extend_7'),
                    value: '7'
                }
            ]
        }
    },
    computed: {
        ...mapGetters({
            userInfo: 'coreApi/getUserInfo',
            userExtend: 'coreApi/getUserExtend'
        }),
        filterSchoolOption() {
            if(this.schooltFilterText !== '') {
                let text = this.schooltFilterText.toLowerCase()

                let schoolRes = this.schoolOption.filter(function(e) {
                    return e.name.toLowerCase().indexOf(text) >= 0
                })

                if(schoolRes.length === 0) {
                    return [{code: null, name: this.schooltFilterText, type: null}]
                } else {
                    return schoolRes
                }
            } else {
                return this.schoolOption
            }
        },
        getLayerOneList() {
            let res = []
            let lang = this.$i18n.locale
            let fun = this.getLayerTwoList
            countrys.forEach(function(c) {
                if(c.l === lang && c.t === 'c') {
                    res.push({
                        value: c.c,
                        label: c.cN,
                        fun: fun
                    })
                }
            })

            if(lang === 'zh-tw') {
                res.sort(function(a) {
                    if(a.label === '臺灣') {
                        return -1
                    } else {
                        return 1
                    }
                })
            }
            return res
        }
    },
    created() {
    },
    mounted() {
        if(this.userExtend) {
            let lang = this.$i18n.locale
            let keys = Object.keys(this.userExtend)
            keys.forEach(k => {
                let baseEx = this.userExtend[k]
                if(baseEx !== null && baseEx !== '') {
                    switch(k) {
                        case 'country': {
                            if(baseEx) {
                                let temp = countrys.filter(c => (c.c === baseEx && c.l === lang && c.t === 'c'))
                                if(temp.length > 0) {
                                    this.extendform[k] = baseEx
                                    this.extendform.areaStr = temp[0]?.cN
                                }
                            }
                            break
                        }
                        case 'province': {
                            if(baseEx) {
                                let areaType = this.extendform.country === 'TW' ? 'y' : 'p'
                                let serchKey = this.extendform.country === 'TW' ? 'y' : 'p'
                                let temp = countrys.filter(c => (
                                    c.c === this.extendform.country &&
                                    c[serchKey] === baseEx &&
                                    c.l === lang &&
                                    c.t === areaType)
                                )
                                if(temp.length > 0) {
                                    this.extendform[k] = baseEx
                                    this.extendform.areaStr += `/${temp[0][serchKey + 'N']}`
                                }
                            }
                            break
                        }
                        case 'city': {
                            if(baseEx) {
                                let areaType = this.extendform.country === 'TW' ? 'd' : 'y'
                                let serchKey = this.extendform.country === 'TW' ? 'd' : 'y'
                                let temp = countrys.filter(c => (
                                    c.c === this.extendform.country &&
                                    c[serchKey] === baseEx &&
                                    c.l === lang &&
                                    c.t === areaType)
                                )
                                if(temp.length > 0) {
                                    this.extendform[k] = baseEx
                                    this.extendform.areaStr += `/${temp[0][serchKey + 'N']}`
                                }
                            }
                            break
                        }
                        // case 'unitName':
                        //     if(this.userExtend['schoolCode']) {
                        //         this.extendform[k] = baseEx
                        //     }
                        // break
                        default:
                        this.extendform[k] = baseEx
                    }
                }
            })
        } else {
            switch(this.$i18n.locale) {
                case 'zh-tw':
                    this.extendform.countryCode = 886
                break
                case 'zh-cn':
                    this.extendform.countryCode = 86
                break
                case 'en-us':
                    this.extendform.countryCode = 1
                break
            }
        }
    },
    methods: {
        handleSubmit(name) {
            this.$refs[name].validate(async(valid) => {
                if (valid) {
                    this.$Spin.show() // 開啟加載畫面

                    if(this.extendform.countryCode.toString() === '886' && this.extendform.mobile.length === 10) {
                        this.extendform.mobile = this.extendform.mobile.toString().slice(1)
                    }

                    // 申請加入學校
                    await this.$store.dispatch('ies5Api/applySchool', this.extendform.schoolCode)
                    // 申請加入頻道
                    await this.$store.dispatch('sokplatformApi/applyChannel', this.extendform.schoolCode)

                    await this.$store.dispatch('coreApi/setUserContact', this.extendform).then(() => {
                        this.$router.push({ name: 'userinfo' })
                    }).catch(e => {
                        this.$Message.warning({
                            content: this.$t('error_18'),
                            duration: 5,
                            closable: true
                        })
                    }).finally(() => {
                        this.$Spin.hide()
                    })
                }
            })
        },
        setSchool(name, type, code) {
            this.extendform.unitName = name
            this.extendform.schoolCode = code
            if(type) {
                this.extendform.unitType = type
            }
            this.schoolOptionFlag = false
        },
        openSchoolOption() {
            this.$refs['extendform'].validateField('areaStr', async(val) => {
                if(!val) {
                    this.$Spin.show() // 開啟加載畫面
                    this.schoolOptionFlag = true
                    let data = {
                        country: this.extendform.country,
                        province: this.extendform.province,
                        city: this.extendform.city
                    }
                    await this.$store.dispatch('coreApi/getSchoolData', data).then(res => {
                        this.schoolOption = res
                    }).catch((e) => {
                        console.log(e)
                    }).finally(() => {
                        this.$Spin.hide() // 關閉加載畫面
                    })
                }
            })
        },
        openAreaOption() {
            this.areaOptionFlag = true
            switch (this.$i18n.locale) {
                case 'ja-jp':
                    this.getLayerTwoList('JP', '日本')
                    break
                case 'ko-kr':
                    this.getLayerTwoList('KR', '대한민국')
                    break
                default:
                    this.areaOption = this.getLayerOneList
                    break
            }
        },
        getLayerTwoList(id, name) {
            let lang = this.$i18n.locale
            let fun = this.getLayerThrList
            this.extendform.country = id
            this.extendform.areaStr = name

            // 清空
            this.extendform.province = null
            this.extendform.city = null
            this.extendform.schoolCode = null
            this.extendform.unitName = null

            this.maskFlag = false
            let res = []
            if(this.extendform.country === 'TW') {
                countrys.forEach(function(c) {
                    if(c.l === lang && c.t === 'y' && c.c === id) {
                        res.push({
                            value: c.y,
                            label: c.yN,
                            fun: fun
                        })
                    }
                })
            } else {
                countrys.forEach(function(c) {
                    if(c.l === lang && c.t === 'p' && c.c === id) {
                        res.push({
                            value: c.p,
                            label: c.pN,
                            fun: fun
                        })
                    }
                })
            }
            if(res.length > 0) {
                this.areaOption = res
            } else {
                this.areaOptionFlag = false
            }
        },
        getLayerThrList(id, name) {
            this.extendform.province = id
            this.extendform.areaStr += `/${name}`

            let res = []
            let fun = this.setThrId
            let lang = this.$i18n.locale
            let country = this.extendform.country

            if(country === 'TW') {
                countrys.forEach(function(c) {
                    if(c.l === lang && c.t === 'd' && c.c === country && c.y === id) {
                        res.push({
                            value: c.d,
                            label: c.dN,
                            fun: fun
                        })
                    }
                })
            } else {
                // 北京 天津 上海 重慶 不用往下選
                let exception = ['11', '12', '31', '50']
                if(country === 'CN' && exception.indexOf(id) >= 0) {
                    // 不處理
                } else {
                    countrys.forEach(function(c) {
                        if(c.l === lang && c.t === 'y' && c.c === country && c.p === id) {
                            res.push({
                                value: c.y,
                                label: c.yN,
                                fun: fun
                            })
                        }
                    })
                }
            }

            if(res.length > 0) {
                this.areaOption = res
            } else {
                // 解開遮罩所調
                this.maskFlag = true
                // 關閉抽屜
                this.areaOptionFlag = false
            }
        },
        setThrId(thrId, thrName) {
            this.extendform.city = thrId
            this.extendform.areaStr += `/${thrName}`

            // 解開遮罩所調
            this.maskFlag = true
            // 關閉抽屜
            this.areaOptionFlag = false
        },
        backToUserinfo() {
            this.$router.push({ name: 'userinfo' })
        }
    },
    components: {
        CountryCode
    }
}
